import { XCircle, ArrowLeft } from "lucide-react";
import { LOGO } from "@/components/site/assets";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="max-w-md text-center">
        <img src={LOGO} alt="JJ Speed Factory" className="h-10 w-auto object-contain mx-auto mb-8" />
        <XCircle size={48} className="mx-auto text-white/60 mb-6" />
        <h1 className="font-display font-black uppercase tracking-tighter text-3xl mb-4">Checkout Cancelled</h1>
        <p className="text-white/60 mb-6">No charge was made. You can restart whenever you're ready.</p>
        <a href="/online-coaching" className="inline-flex items-center gap-2 bg-white text-black font-bold uppercase tracking-widest text-sm px-8 py-4 hover:bg-white/85 transition-colors" data-testid="cancel-retry-btn">
          <ArrowLeft size={16} /> Back to Signup
        </a>
      </div>
    </div>
  );
}
